export class CsrfHandler {
  private token: string | null = null;

  getToken(): string | null {
    return this.token;
  }

  setToken(token: string | null): void {
    this.token = token;
  }

  clear(): void {
    this.token = null;
  }
}

type CsrfHandlerGlobal = typeof globalThis & {
  __cmx_csrfHandler?: CsrfHandler;
};

const g = globalThis as CsrfHandlerGlobal;

const _csrfHandler: CsrfHandler =
  g.__cmx_csrfHandler ?? (g.__cmx_csrfHandler = new CsrfHandler());

/** Returns the shared CSRF handler pinned on `globalThis`. */
export function getCsrfHandler(): CsrfHandler {
  return g.__cmx_csrfHandler ?? (g.__cmx_csrfHandler = new CsrfHandler());
}

/** Replaces the shared `globalThis.__cmx_csrfHandler` singleton. */
export function setCsrfHandler(handler: CsrfHandler): void {
  g.__cmx_csrfHandler = handler;
}

export default _csrfHandler;
